__webpack_require__.p = "/lab1/";